import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  create(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/routine-definitions`
    return HTTP.post(url, data)
  },

  get(organizationId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/organizations/${organizationId}/routine-definitions`
    return HTTP.get(url, params)
  },

  getStreamRoutineDefinition(args = {}) {
    const {
      organizationId,
      filters = {},
      sort = {},
      limit,
      from,
      page,
      terms,
      projections = [],
      expansions = [],
    } = args
    const params = {
      filters,
      sort,
      from,
      limit,
      page,
      terms,
      projections,
      expansions,
    }
    const url = `api/v1/stream/${organizationId}/routine-definitions`
    return HTTP.get(url, {
      params,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    })
  },

  getById(organizationId, routineId) {
    const url = `/api/v1/organizations/${organizationId}/routine-definitions/${routineId}`
    return HTTP.get(url)
  },

  update(organizationId, routineId, data) {
    const url = `/api/v1/organizations/${organizationId}/routine-definitions/${routineId}`
    return HTTP.patch(url, data)
  },

  delete(organizationId, routineId) {
    const url = `/api/v1/organizations/${organizationId}/routine-definitions/${routineId}`
    return HTTP.delete(url)
  },

  start(organizationId, data) {
    return HTTP.post(`/api/v1/organizations/${organizationId}/routines`, data)
  },

  getExecutionById(organizationId, routineExecutionId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/routines/${routineExecutionId}`,
      params
    )
  },

  getRoutineExecutions(organizationId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/organizations/${organizationId}/routines`
    return HTTP.get(url, params)
  },

  updateRoutineExecution(organizationId, routineId, data) {
    const url = `/api/v1/organizations/${organizationId}/routines/${routineId}`
    return HTTP.patch(url, data)
  },

  deleteRoutineExecutions(organizationId, routineId) {
    const url = `/api/v1/organizations/${organizationId}/routines/${routineId}`
    return HTTP.delete(url)
  },

  createChecklist(organizationId, data) {
    return HTTP.post(`/api/v1/organizations/${organizationId}/checklists`, data)
  },

  updateChecklist(organizationId, checklistId, data) {
    return HTTP.patch(
      `/api/v1/organizations/${organizationId}/checklists/${checklistId}`,
      data
    )
  },

  getChecklistById(organizationId, checklistId) {
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/checklists/${checklistId}`
    )
  },

  createChecklistResponse(organizationId, checklistId, data) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/checklists/${checklistId}/responses`,
      data
    )
  },

  updateChecklistResponse(organizationId, checklistId, responseId, data) {
    return HTTP.patch(
      `/api/v1/organizations/${organizationId}/checklists/${checklistId}/responses/${responseId}`,
      data
    )
  },

  getChecklistResponseById(organizationId, checklistId, responseId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    return HTTP.get(
      `/api/v1/organizations/${organizationId}/checklists/${checklistId}/responses/${responseId}`,
      params
    )
  },

  duplicateRoutine(organizationId, originRoutineId) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/routine-definitions/duplicate/${originRoutineId}`
    )
  },

  createRoutineApproval(organizationId, routineId, data) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/routines/${routineId}/approvals`,
      data
    )
  },

  removeRoutineApproval(organizationId, routineId, approvalId) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/routines/${routineId}/approvals/${approvalId}`
    )
  },

  updateRoutineApproval(organizationId, routineId, approvalId, data) {
    return HTTP.patch(
      `/api/v1/organizations/${organizationId}/routines/${routineId}/approvals/${approvalId}`,
      data
    )
  },

  getRoutineApprovals(organizationId, routineId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/routines/${routineId}/approvals`,
      params
    )
  },

  getRoutineApprovalById(organizationId, routineId, approvalId) {
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/routines/${routineId}/approvals/${approvalId}`
    )
  },

  // In order to link attachment, the id for its "media" attribute must be provided. Do not confuse attachment.id with attachment.media.id
  linkAttachmentToRoutineApproval(
    organizationId,
    approvalId,
    attachmentMediaId
  ) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/routine-approvals/${approvalId}/attachments`,
      { media: attachmentMediaId }
    )
  },

  // To unlink an attachment, the attachment.id field is required, not attachment.media.id
  unlinkAttachmentFromRoutineApproval(
    organizationId,
    approvalId,
    attachmentId
  ) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/routine-approvals/${approvalId}/attachments/${attachmentId}`
    )
  },

  getRoutineApprovalAttachments(organizationId, approvalId) {
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/routine-approvals/${approvalId}/attachments`
    )
  },
}
